import {useMutation, useQueryClient} from "react-query";
import axios from "services/axios";

import {QUERY_CUSTOM_PAYMENT_METHOD} from "./useQueryPaymentMethod";

export function useAddCustomPaymentMethod() {
	const queryClient = useQueryClient();

	return useMutation(payload => axios.post("/v2/payment-methods/create", payload).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY_CUSTOM_PAYMENT_METHOD);
		},
	});
}

export function useEditCustomPaymentMethod() {
	const queryClient = useQueryClient();

	return useMutation(
		({id, payload}) =>
			axios
				.post("/v2/payment-methods/update", {
					id,
					...payload,
				})
				.then(res => res.data),
		{
			onSuccess: () => {
				queryClient.invalidateQueries(QUERY_CUSTOM_PAYMENT_METHOD);
			},
		},
	);
}

export function useDeleteCustomPaymentMethod() {
	const queryClient = useQueryClient();

	return useMutation(id => axios.post("/v2/payment-methods/delete", {id}).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY_CUSTOM_PAYMENT_METHOD);
		},
	});
}
